import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/sundar21017'
      className='link footer__link'
    >
      Created By Sundar
    </a>
  </footer>
)

export default Footer
